export default class Header {
	constructor() {
		this.header = document.querySelector("header");
		this.menu = document.querySelector(".btnMobileMenu");
		this.menuOpen = document.querySelector(".menu-header-container");

        this.btnOpemModalWhats = document.querySelector('.btnOpemModalWhatsApp')
		
		this.ready();
        // this.scroll();

        this.modalWhatsApp()
	}

	ready() {

		this.menu.addEventListener("click", () => {
			this.menuOpen.classList.toggle("active");
			this.menu.classList.toggle("active");
			if (document.querySelector(".home")) {
				this.header.classList.toggle("active");
			} else {
				if (!this.header.classList.contains("active")) {
					this.header.classList.add("active");
				}
			}
			if (this.menu.classList.contains("active")) {
				this.header.classList.add("active");
			}
		}, false);

	}

    scroll() {

        // let lastScrollTop = 0;

        // // Função que é chamada quando o usuário rola a página
        // window.addEventListener('scroll', () => {
        //     // Obtém a posição atual de rolagem
        //     let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        //     // Verifica se a rolagem é maior que 160px
        //     if (currentScrollTop > 300) {
        //         // Verifica se a rolagem é para cima ou para baixo
        //         if (currentScrollTop > lastScrollTop) {
        //             // Rolando para baixo
        //             this.header.classList.remove('showHeader');
        //         } else {
        //             // Rolando para cima
        //             this.header.classList.add('showHeader');
        //         }
        //     } else {
        //         // Se a rolagem é menor ou igual a 180px, remova a classe 'showHeader'
        //         this.header.classList.remove('showHeader');
        //     }

        //     // Atualiza a última posição de rolagem
        //     lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Evita números negativos
        // });

    }

    modalWhatsApp() {

        this.btnOpemModalWhats.addEventListener('click', () => {
            document.querySelector('#modalWhatsSelecao').classList.toggle('active')
            document.querySelector('#modalWhatsSelecao #closeModal').addEventListener('click', () => {
                document.querySelector('#modalWhatsSelecao').classList.toggle('active')
            })
        })

    }

}

new Header();